/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_SchoolInputs */

const de__field_school = /** @type {(inputs: _Field_SchoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner`)
};

/**

* @param {_Field_SchoolInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_school = /** @type {((inputs?: _Field_SchoolInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_SchoolInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_school(inputs)
});